import React from 'react';

import { Typography as E100Typography } from 'e100-react-components';
import { IPropTypes } from 'e100-react-components/lib/components/Typography';

import { useStyles } from './styles';

export const Typography = ({
  textAlign,
  whiteSpace,
  ...props
}: TypographyProps) => {
  const classes = useStyles({ variant: props.variant, textAlign, whiteSpace });
  return (
    <E100Typography
      {...props}
      classes={{
        ...props.classes || {},
        root: `${classes.root} ${(props.classes || {}).root}`
      }}
    />
  );
};

type TextAlign = 'left' | 'center' | 'right';

export interface TypographyProps extends IPropTypes {
  textAlign?: TextAlign;
  whiteSpace?: 'normal' | 'nowrap' | 'pre' | 'pre-wrap' | 'pre-line' | 'break-spaces' | 'inherit' | 'initial' | 'unset';
}
